import { Action } from '@ngrx/store';
import { IExternalData } from '../../../commons';

export enum ExternalManagementActionTypes {
  LoadExternalManagementState = '[ExternalManagement] Load ExternalManagement State',
  LoadExternalManagementStateSuccess = '[ExternalManagement] Load ExternalManagement State Success',
  LoadExternalManagementStateFail = '[ExternalManagement] Load ExternalManagement State Fail',
  ExternalManagementScreenErrorReset = '[ExternalManagement] ExternalManagement Screen Error Reset',
  ApproveUser = '[ExternalManagement] ExternalManagement Approve User',
  ApproveUserSuccess = '[ExternalManagement] ExternalManagement Approve User Success',
  ApproveUserFailed = '[ExternalManagement] ExternalManagement Approve User Failed',
  RejectUser = '[ExternalManagement] ExternalManagement Reject User',
  RejectUserSuccess = '[ExternalManagement] ExternalManagement Reject User Success',
  RejectUserFailed = '[ExternalManagement] ExternalManagement Reject User Failed',
  AddExceptionEINState = '[ExternalManagement] Add Org Info Detail to EIN Exception List',
  AddExceptionEINStateSuccess = '[ExternalManagement]Add Org Info Detail to EIN Exception List Success ',
  AddExceptionEINStateFail = '[ExternalManagement] Failed to add Org Info Detail to EIN Exception List',
  CharityCheckState = '[ExternalManagement] Charity Check EIN via guidestar',
  CharityCheckStateSuccess = '[ExternalManagement] Charity Check EIN via guidestar success',
  CharityCheckStateFail = '[ExternalManagement] failed to do Charity Check EIN via guidestar',
}

export class LoadExternalManagementState implements Action {
  readonly type = ExternalManagementActionTypes.LoadExternalManagementState;
}

export class LoadExternalManagementStateSuccess implements Action {
  readonly type =
    ExternalManagementActionTypes.LoadExternalManagementStateSuccess;
  constructor(public payload: IExternalData[]) {}
}

export class LoadExternalManagementStateFail implements Action {
  readonly type = ExternalManagementActionTypes.LoadExternalManagementStateFail;
  constructor(public payload: any) {}
}

export class ExternalManagementScreenErrorReset implements Action {
  readonly type =
    ExternalManagementActionTypes.ExternalManagementScreenErrorReset;
}

export class ApproveUser implements Action {
  readonly type = ExternalManagementActionTypes.ApproveUser;
  constructor(public payload: IExternalData) {}
}

export class ApproveUserFailed implements Action {
  readonly type = ExternalManagementActionTypes.ApproveUserFailed;
  constructor(public payload: string) {}
}

export class ApproveUserSuccess implements Action {
  readonly type = ExternalManagementActionTypes.ApproveUserSuccess;
  constructor(public payload: string) {}
}

export class RejectUser implements Action {
  readonly type = ExternalManagementActionTypes.RejectUser;
  constructor(public payload: IExternalData) {}
}

export class RejectUserFailed implements Action {
  readonly type = ExternalManagementActionTypes.RejectUserFailed;
  constructor(public payload: string) {}
}

export class RejectUserSuccess implements Action {
  readonly type = ExternalManagementActionTypes.RejectUserSuccess;
  constructor(public payload: string) {}
}

export class AddExceptionEIN implements Action {
  readonly type = ExternalManagementActionTypes.AddExceptionEINState;
  constructor(public externalData: IExternalData, public isApproving: boolean) {}
}
export class AddExceptionEINSuccess implements Action {
  readonly type = ExternalManagementActionTypes.AddExceptionEINStateSuccess;
  constructor(public message: string) {}
}
export class AddExceptionEINFail implements Action {
  readonly type = ExternalManagementActionTypes.AddExceptionEINStateFail;
  constructor(public errorMessage: string) {}
}

export class CharityCheck implements Action {
  readonly type = ExternalManagementActionTypes.CharityCheckState;
  constructor(public externalData: IExternalData) {}
}
export class CharityCheckSuccess implements Action {
  readonly type = ExternalManagementActionTypes.CharityCheckStateSuccess;
  constructor(public message: string) {}
}
export class CharityCheckFail implements Action {
  readonly type = ExternalManagementActionTypes.CharityCheckStateFail;
  constructor(public errorMessage: string) {}
}

export type ExternalManagementActions =
  | LoadExternalManagementState
  | LoadExternalManagementStateSuccess
  | LoadExternalManagementStateFail
  | ExternalManagementScreenErrorReset
  | ApproveUser
  | ApproveUserSuccess
  | ApproveUserFailed
  | RejectUser
  | RejectUserSuccess
  | RejectUserFailed
  | AddExceptionEIN
  | AddExceptionEINSuccess
  | AddExceptionEINFail
  | CharityCheck
  | CharityCheckSuccess
  | CharityCheckFail;
